<template>
  <div class="accodion_box accodion_payment apay-loose">
    <div class="accodion_box_tit">
      <a href="#target_payment" data-toggle="collapse" aria-expanded="true">
        <div class="panel-title">
          <span class="text-uppercase accordion-header-text">결제수단</span>
          <span class="pull-right icon-arr" />
        </div>
      </a>
    </div>
    <div
      id="target_payment"
      class="accodion_box_cont0 collapse in"
      aria-expanded="true"
    >
      <!-- 암웨이페이 -->
      <amway-pay
        :style="styleAmwayPaymentBackgroundColor"
        :payment-method-info="paymentMethodInfo"
        :amway-pay-methods="amwayPayMethods"
        :cash-receipt="cashReceipt"
        :can-installing="canInstalling"
        @update-payment-info="updateAmwayPayMethodInfo"
        @update-receipt-info="$emit('update-receipt-info', $event)"
      />

      <!-- 다른 결제수단 -->
      <other-pay
        :payment-method-info="paymentMethodInfo"
        :style="styleOtherPaymentBackgroundColor"
        :can-installing="canInstalling"
        :cash-receipt="cashReceipt"
        @update-payment-info="updateOtherPayMethodInfo"
        @toggle-other-pay="toggleOtherPay"
        @update-receipt-info="$emit('update-receipt-info', $event)"
      />
    </div>
  </div>
</template>

<script>
import {
  PAYMENT_METHODS,
  AMWAY_PAY_METHODS,
  NORMAL_PAYMENT_METHODS,
} from "@/utils/constants";
import AmwayPay from "@/views/order/main/components/Payment/AmwayPay";
import OtherPay from "@/views/order/main/components/Payment/OtherPay";
import { log } from "@/utils/common";
import { mapGetters } from "vuex";

export default {
  name: "PaymentMethods",
  components: { OtherPay, AmwayPay },
  data() {
    return {
      selectedPaymentMethod: "",
      selectedOtherPayMethod: "",
      selectedAmwayPayMethod: "",
    };
  },
  mounted() {
    if (this.currentOrderMode != null) {
      this.selectedPaymentMethod = this.currentOrderMode;
    }
    if (this.currentAmwayPayMode != null) {
      this.selectedAmwayPayMethod = this.currentAmwayPayMode;
    }
    if (this.currentOtherPayMode != null) {
      this.selectedOtherPayMethod = this.currentOtherPayMode;
    }
  },
  computed: {
    ...mapGetters({
      currentOrderMode: "order/currentOrderMode",
      currentAmwayPayMode: "order/currentAmwayPayMode",
      currentOtherPayMode: "order/currentOtherPayMode",
    }),
    appliedPromotion() {
      return this.promotionInfo.length > 0 ? this.promotionInfo[0] : null;
    },
    styleOtherPaymentBackgroundColor() {
      return this.selectedPaymentMethod === PAYMENT_METHODS.NORMAL
        ? { backgroundColor: "#f4f4f4" }
        : { backgroundColor: "#fff" };
    },
    styleAmwayPaymentBackgroundColor() {
      return this.selectedPaymentMethod === PAYMENT_METHODS.AMWAY_PAY
        ? { backgroundColor: "#f4f4f4" }
        : { backgroundColor: "#fff" };
    },
    paymentMethodInfo() {
      return {
        paymentMethod: this.selectedPaymentMethod,
        otherPaymentMethod: this.selectedOtherPayMethod,
        amwayPayMethod: this.selectedAmwayPayMethod,
      };
    },
  },
  watch: {
    paymentMethodInfo(newValue, oldValue) {
      this.$emit("update-cart-info", newValue);
    },
  },
  methods: {
    updateAmwayPayMethodInfo(data) {
      this.selectedPaymentMethod = data.selectedPaymentMethod;
      this.selectedAmwayPayMethod = data.selectedAmwayPayMethod;

      this.$store.commit("order/changeOrderMode", this.selectedPaymentMethod);
      this.$store.commit(
        "order/changeAmwayPayMode",
        this.selectedAmwayPayMethod
      );
    },
    updateOtherPayMethodInfo(data) {
      this.selectedPaymentMethod = data.selectedPaymentMethod;
      this.selectedOtherPayMethod = data.selectedOtherPayMethod;

      this.$store.commit(
        "order/changeOtherPayMode",
        this.selectedOtherPayMethod
      );
    },
    toggleOtherPay(checked) {
      this.selectedPaymentMethod = checked
        ? PAYMENT_METHODS.NORMAL
        : PAYMENT_METHODS.AMWAY_PAY;
      this.$store.commit("order/changeOrderMode", this.selectedPaymentMethod);
    },
  },
  props: {
    promotionInfo: {
      type: Array,
      required: true,
    },
    amwayPayMethods: {
      type: Object,
      required: true,
    },
    canInstalling: {
      type: Boolean,
      default: false,
    },
    cashReceipt: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/main/components/Payment/PaymentMethods.vue